export const FACILITY_INDEX_TITLE =
  'ビジター利用(都度利用)可能なジム・スタジオ一覧'
export const FACILITY_INDEX_SEARCH_TITLE =
  'ビジター利用(都度利用)可能なジム・スタジオの検索結果'
